export default "<router-outlet></router-outlet>\r\n<app-drawer-container></app-drawer-container>\r\n<app-fab-container></app-fab-container>\r\n";